// Copy for the "Select your preferences" screen. Chrome/labels only — the offering data
// (modality, duration, provider label) comes from the BFF and is composed at render time.
// English-only literal strings, like the rest of this package.

import type { Offering } from "./hooks"

// The visit-type card title + description, keyed by the offering's `appointmentType`.
const APPOINTMENT_TYPE_COPY: Record<Offering["appointmentType"], { title: string; description: string }> = {
  initial: {
    title: "Initial consult",
    description:
      "Your first visit with a Carrot Clinic clinician. We'll match you with the first available provider, and you can schedule follow-up visits afterward."
  },
  follow_up: {
    title: "Follow-up visit",
    description: "Continue with a Carrot Clinic clinician you've met with before."
  }
}

export function appointmentTypeCopy(appointmentType: Offering["appointmentType"]): {
  title: string
  description: string
} {
  return APPOINTMENT_TYPE_COPY[appointmentType]
}
